import { Image5 } from "./image5";
import React from "react";

export const Gallery5 = (props) => {
  return (
    <div id="Youtube_thumbnails" className="text-center">
      <div className="container">
        <div className="section-title">
          <br></br><br></br>
          <h1>Richest Family Thumbnail</h1>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title5}-${i}`}
                    className="col-sm-6 col-md-3 col-lg-4"
                  >
                    <Image5
                      title5={d.title5}
                      largeImage5={d.largeImage5}
                      smallImage5={d.smallImage5}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
    
  );
};

